// Cuddelan scroll-reveal: tags content blocks and reveals them on entry.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTORS = [
    '.shopify-section > .section-wrapper',
    '.shopify-section .product-grid > *',
    '.shopify-section .resource-list__item',
    '.shopify-section .section-content-wrapper > *'
  ].join(',');

  function tag(root) {
    var nodes = (root || document).querySelectorAll(SELECTORS);
    var i = 0;
    nodes.forEach(function (el) {
      if (el.hasAttribute('data-cdl-reveal')) return;
      if (el.closest('.cdl-hero')) return;          // hero animates itself
      if (el.closest('#header-group')) return;      // never hide the header
      if (el.closest('footer')) return;             // footer stays visible
      el.setAttribute('data-cdl-reveal', '');
      el.style.setProperty('--cdl-delay', (i % 4) * 70 + 'ms');
      i++;
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('cdl-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  function observe() {
    document.querySelectorAll('[data-cdl-reveal]:not(.cdl-in)').forEach(function (el) {
      io.observe(el);
    });
  }

  function run() {
    tag(document);
    observe();
    // Safety net: anything still hidden after 2.5s gets revealed.
    setTimeout(function () {
      document.querySelectorAll('[data-cdl-reveal]:not(.cdl-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('cdl-in');
      });
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-tag after Shopify section re-renders (theme editor, cart updates)
  document.addEventListener('shopify:section:load', function () { run(); });
})();
